import React from 'react';

import InNavbar from './navbar.types';

import NavbarComponent from './navbar.component';

const NavbarContainer: React.FC<InNavbar> = (props: InNavbar) => {
  return <NavbarComponent logoGoTo={props.goTo} />;
};

export default NavbarContainer;
